import { render, staticRenderFns } from "./OrderDetailNotes.vue?vue&type=template&id=53caac73&scoped=true"
import script from "./OrderDetailNotes.vue?vue&type=script&lang=js"
export * from "./OrderDetailNotes.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailNotes.vue?vue&type=style&index=0&id=53caac73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53caac73",
  null
  
)

export default component.exports